import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import styles from './printLabel.scss';

class PrintLabel extends Component {

  componentDidMount() {
    window.print();
  }

  render() {
    const { queryData } = this.props.location.query;
    const stringifiedQuery = atob(JSON.parse(queryData));
    const query = JSON.parse(stringifiedQuery);

    return (<Fragment>
      {query.map(item => <Fragment key={item.poNumber}>
        <div className={styles.wrapper}>
          <p className={styles.wrapperParagraph}>{item.customerName.toUpperCase()}</p>
          <p className={styles.wrapperParagraph}>{item.poNumber}</p>
          <p className={styles.wrapperParagraph}>{item.storeNumber}</p>
          <p className={styles.wrapperParagraph}>{item.itemName}</p>
          <p className={styles.wrapperParagraph}>Quantity: {Math.floor(item.quantity)}</p>
          <p className={`${styles.wrapperParagraph} ${styles.isLarge}`}>{item.tagNumber}</p>
          <p className={styles.wrapperParagraph}>{item.dateReceived}</p>
          <p className={styles.wrapperParagraph}>{item.bin}</p>
          <br />
          {item.pads.length > 0 && item.pads.map(pad =>
            <div key={pad.description}>
              <p className={styles.wrapperParagraph}>{pad.description}</p>
              <p className={styles.wrapperParagraph}>{pad.cut_quantity}</p>
            </div>)}
        </div>
        <footer />
      </Fragment>)}
    </Fragment>
    );
  }
}

PrintLabel.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      queryData: PropTypes.string,
    }),
  }),
};

export default PrintLabel;



// WEBPACK FOOTER //
// ./client/app/screens/printLabel/index.jsx